import { Component, OnDestroy, OnInit } from "@angular/core";
import { ModalService } from "../../services/modal.service";
import { NotificationService } from "../../services/notification.service";
import { Subscription } from "rxjs";
import { CardDataService } from "./services/card-data.service";
import { SavedCardDto } from "./models/saved-card.models";
import { SavedCardService } from "../../services/saved-card.service";
import { MenuStateService } from "../../services/menu-state.service";

@Component({
	selector: "app-saved-card-list",
	templateUrl: "./saved-card-list.component.html",
	styleUrls: ["./saved-card-list.component.scss"],
})
export class SavedCardListComponent implements OnInit, OnDestroy {
	tabSelect: string | "activated" | "deactivated" = "activated";

	isAddCardModalDialog = false;
	isDeleteCardModalDialog = false;
	isDeleteSuccessCardModalDialog = false;
	isAddSuccessCardModalDialog = false;

	activeCardList: SavedCardDto[] = [];
	blockedCardList: SavedCardDto[] = [];
	allCard: SavedCardDto[] = [];
	mainCard: SavedCardDto | undefined;

	subs: Subscription[] = [];

	deleteCardData!: SavedCardDto;

	menuState = false;

	constructor(
		private modalService: ModalService,
		private notificationService: NotificationService,
		private cardDataService: CardDataService,
		private savedCardService: SavedCardService,
		private menuStateService: MenuStateService
	) {}

	ngOnInit() {
		this.initModal();
		this.loadActiveCardList();
		this.subscribeCardService();
		this.initMenuState();
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	initMenuState() {
		this.subs.push(
			this.menuStateService.menuState$.subscribe({
				next: (res) => {
					this.menuState = res;
				},
			})
		);
	}

	loadActiveCardList() {
		this.cardDataService.loadActiveCardList().subscribe({
			next: (res) => {
				this.activeCardList = res.content;
				this.loadBlockedCardList();
			},
		});
	}

	loadBlockedCardList() {
		this.cardDataService.loadBlockedCardList().subscribe({
			next: (res) => {
				this.blockedCardList = res.content;
				this.findMainCard();
			},
		});
	}

	findMainCard() {
		this.allCard.push(...this.activeCardList);
		this.allCard.push(...this.blockedCardList);
		this.mainCard = this.allCard.find((item: { is_main: boolean }) => item.is_main);

		for (let i = 0; i < this.activeCardList.length; i++) {
			if (this.activeCardList[i].is_main) {
				this.activeCardList.splice(i, 1);
				return;
			}
		}
	}

	subscribeCardService() {
		this.subs.push(
			this.savedCardService.activatedCardCompleted$.subscribe({
				next: () => {
					this.updateCardList();

					this.notificationService.setConfiguration(
						"icon-2",
						"warning",
						"SAVED_CARD_PAGE.NOTIFICATION_ACTIVATED.TITLE",
						"SAVED_CARD_PAGE.NOTIFICATION_ACTIVATED.DESCRIPTION"
					);

					this.notificationService.showNotification();
				},
			})
		);

		this.subs.push(
			this.savedCardService.blockedCardCompleted$.subscribe({
				next: () => {
					this.updateCardList();

					this.notificationService.setConfiguration(
						"icon-1",
						"warning",
						"SAVED_CARD_PAGE.NOTIFICATION_DEACTIVATED.TITLE",
						"SAVED_CARD_PAGE.NOTIFICATION_DEACTIVATED.DESCRIPTION"
					);
					this.notificationService.showNotification();
				},
			})
		);

		this.subs.push(
			this.savedCardService.makeMainCardCompleted$.subscribe({
				next: () => {
					this.updateCardList();
				},
			})
		);

		this.subs.push(
			this.savedCardService.deleteCardCompleted$.subscribe({
				next: () => {
					this.modalService.closeModal();
					this.updateCardList();
					this.isDeleteSuccessCardModalDialog = true;
				},
			})
		);
	}

	updateCardList() {
		this.allCard = [];
		this.activeCardList = [];
		this.blockedCardList = [];
		this.loadActiveCardList();
	}

	initModal() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => {
					if (!res) {
						this.isAddCardModalDialog = false;
						this.isDeleteCardModalDialog = false;
						this.isDeleteSuccessCardModalDialog = false;
						this.isAddSuccessCardModalDialog = false;
					}
				},
			})
		);
	}

	selectTab(tabName: string) {
		if (this.tabSelect !== tabName) {
			this.tabSelect = tabName;
		}
	}

	openAddCardModal() {
		this.isAddCardModalDialog = true;
	}

	cardCreated() {
		this.modalService.closeModal();
		this.updateCardList();
		this.isAddSuccessCardModalDialog = true;
	}

	openModalDeleteCard(item: SavedCardDto) {
		this.deleteCardData = item;
		this.isDeleteCardModalDialog = true;
	}
}
